import { render, staticRenderFns } from "./SchemeCreate.vue?vue&type=template&id=d84ea5c2&"
import script from "./SchemeCreate.vue?vue&type=script&lang=js&"
export * from "./SchemeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports